<template>
  <div class="work-information">
  	<div class="bk-info-box" v-show="!isProductLoading">
  		<!-- 作品视频 -->
	  	<div class="video">
	  	  <h4>
	  	  	作品视频
	  	  	<span class="bk-word">可添加作品的相关视频介绍资料，加深用户对作品的认知</span>
	  	  	<span class="bk-num">
	  	  		<span>{{videoList.length}}</span>/10
	  	  	</span>
	  	  </h4>
	  	  <div class="bk-add-video">
	  	  	<ul class="bk-video-list">
	  	  	  <li v-for="(item, index) in videoList" :key="index">
	  	  	  	<div class="bk-video-img"
	  	  	  	  @mouseenter="showCurVideo(index)" 
	              @mouseleave="hideCurVideo">
	  	  	  	  <img :src="item.logo"/>
	  	  	  	  <div class="bk-shade" v-show="index === video.avatarIndex"  @click="openChangevideo(item, index)">
	  	  	    	  <img src="../../../images/personal_center/video_re.png"/>
	  	  	    	  <p>修改视频信息</p>
	  	  	    	  <i class="bk-icon icon-error" @click.stop.prevent="deleteTheVideo(item, index)"></i>
	  	  	      </div>
	  	  	  	</div>
	  	  	    <p v-html="item.title"></p>
	  	  	  </li>
	  	  	  <li class="bk-background" @click="openAddvideo" v-show="!(videoList.length >= 10)">
	  	  	    <img src="../../../images/personal_center/video_add.png" alt="" />
	  	  	    <p>添加新视频</p>
	  	  	  </li>
	  	  	  <li class="show-line" v-show="videoList.length === 0 || videoList.length === 3 || videoList.length === 6 || videoList.length === 9 || videoList.length === 10"></li>
	  	  	</ul>
	  	  </div>
	  	</div>
	  	<!-- 作品附件 -->
	  	<div class="bk-accessory attention">
	  	  <h4>
	  	  	作品附件
	  	  	<span>可上传作品相关的依赖包或产品说明相关的文档等文件</span>
	  	  </h4>
	  	  <!-- 作品附件列表 -->
	  	  <div v-show="workAccessory">
	  	  	<div class="bk-add-accessory">
		  	  	<div class="bk-add-btn">
		  	  	  <button class="bk-button bk-primary" title="上传附件" @click="changeDoxc">
				        <i class="bk-icon icon-upload"></i>
				        <span>上传附件</span>
				      </button>
		  	  	</div>
		  	  	<div class="bk-table-list">
		  	  	  <table class="bk-table has-table-bordered">
		  	  	  	<colgroup>
		  	  	  	  <col style="width:282px"/>
		  	  	  	  <col style="width:260px"/>
		  	  	  	  <col style="width:170px"/>
		  	  	  	  <col style="width:122px"/>
		  	  	  	</colgroup>
		  	  	  	<tbody>
		  	  	  	  <tr v-for="(item, index) in docxList" :key="index">
		  	  	  	  	<td>
		  	  	  	  	  <img src="../../../images/personal_center/icondocx.png" v-show="item.type !== 'ZIP'"/>
		  	  	  	  	  <img src="../../../images/personal_center/iconzip.png" v-show="item.type === 'ZIP'"/>
		  	  	  	  	  <span class="bk-img-word" v-html="item.name" :title="item.name"></span>
		  	  	  	  	</td>
		  	  	  	  	<td>上传时间：{{item.create_time}}</td>
		  	  	  	  	<td>文件大小：{{item.size}}</td>
		  	  	  	  	<td>
		  	  	  	  	  <i class="bk-icon icon-download" @click="downLoad(item.doc)">
			                <span class="tips" @click="downLoad(item.doc)">版本下载</span>
			              </i>
			              <i class="bk-icon icon-delete" @click="deleteDocx(item, index)">
			                <span class="tips">删除该版本</span>
			              </i>
		  	  	  	  	</td>
		  	  	  	  </tr>
		  	  	  	</tbody>
		  	  	  </table>
		  	  	</div>
		  	  </div>
	  	  </div>
	  	  <!-- 作品附件上传 -->
		  	<div class="bk-add-docx" v-show="!workAccessory">
		  		<div class="bk-docx-top">
		  			<p class="mt20">
			        <i class="bk-icon icon-upload"></i>
		  				<span>将文件拖到此处或</span>
		  				<span class="bk-add">点击上传</span>
		  			</p>
		  			<p class="mt20">
		  				最多仅支持上传10个文件
		  			</p>
		  			<p class="mt10">
		  				单文件最大仅可为 100MB
		  			</p>
		  			<p class="mb25 mt10">
		  				单次上传文件总大小不建议太大，以免影响上传效率体验
		  			</p>
		  			<input type="file" name="uploadFile" @change="handleFile" class="bk-docx-file">
		  		</div>
		  		<div class="bk-docx-content">
		  			<!-- 文件的上传的预览 -->
		        <div class="bk-form-content" v-show="ableToUpload">
		          <div class="bk-upload-ul" v-if="files.length !== 0 && files">
		            <div class="bk-list-li" v-for="(item, index) in uploadFiles" :key="index">
		              <i class="bk-icon icon-file-zip"></i>
		              <div class="bk-list-content">
		                <span class="name">{{item.name}}</span>
		                <!-- <i class="bk-icon icon-close" @click="deleteFile" v-if="loadingIndex === index && loadingStatus === 'start'"></i> -->
		                <i class="bk-icon icon-check-1"></i>
		                <span class="bk-load" v-show="loadingIndex === index && loadingStatus === 'start'">
		                  <span :class="[{'loading': loadingIndex === index && loadingStatus === 'start'}, {'totalLoading': loadingIndex === index && loadingStatus === 'complete'}]"></span>
		                  <span></span>
		                </span>
		              </div>
		            </div>
		          </div>
		        </div>
		  		</div>
		  		<div class="bk-docx-bottom">
						<button :class="['bk-button', 'bk-primary',{'is-loading':saveFlag === false}]" :disabled="addDisabled" @click="changeDocxList">提交</button>
						
		  			<button class="bk-button bk-default" @click="changeDoxc">取消</button>
		  		</div>
		  	</div>  
	  	</div>
  	</div>
  	<!-- 页面弹框效果 /-->
    <div class="bk-open-shade" v-show="shade"></div>
		<!-- 添加视频弹框效果 /-->
		<div class="bk-open-addvideo" v-show="addVideo">
		  <div class="bk-open-top">
				<div class="bk-open-img">
					<div>
						<p v-show="!images.coverUploaded">250x141</p>
				  	<img :src="images.coverImg.indexOf('?') == 0 ? '' : images.coverImg" alt="" v-show="images.coverUploaded" class="bk-img"/>
					</div>
				  <div class="mask-loading" v-show="images.coverUploading">
            <div class="loading-box">
	            <div class="loading">
                <div class="strip1 strip"></div>
                <div class="strip2 strip"></div>
                <div class="strip3 strip"></div>
                <div class="strip4 strip"></div>
                <div class="strip5 strip"></div>
                <div class="strip6 strip"></div>
                <div class="strip7 strip"></div>
                <div class="strip8 strip"></div>
                <div class="strip9 strip"></div>
                <div class="strip10 strip"></div>
                <div class="strip11 strip"></div>
                <div class="strip12 strip"></div>
	            </div>
	            <div class="text">
	                正在上传图片...
	            </div>
            </div>
        	</div>
			    <input type="file" name="avatar" class="bk-change-img" accept="image/*" @change="imgOnChange($event, 'cover')" title="更换图片">
				</div>
				<div class="bk-open-form">
			    <form class="bk-form">
			    	<div class="bk-form-item">
			    		<label class="bk-label">选择封面：</label>
	            <div class="bk-form-content">
	              <div class="bk-open-file">
	              	选择文件
	              	<input type="file" accept="image/*" @change="imgOnChange($event, 'cover')"/>
	              </div>
	              <span class="bk-open-span">图片类型仅支持jpg/jpeg/png</span>
	            </div>
	          </div>
            <div class="bk-form-item bk-form-mt">
	            <label class="bk-label">视频名称：</label>
	            <div class="bk-form-content" >
	              <input 
	              	type="text" 
	              	class="bk-form-input" 
	              	v-bind:class="{'bk-input-checked': classStats.titleShow}" 
	              	name="validation_name" 
	              	placeholder="填写该视频内容的主要标题，最多10个字" 
	              	v-model="videoInfo.title" 
	              	@input="checkAddTitle">
	            </div>
            </div>
            <div class="bk-form-item">
	            <label class="bk-label">视频链接：</label>
	            <div class="bk-form-content" >
	              <input 
	              	type="text" 
	              	class="bk-form-input" 
	              	v-bind:class="{'bk-input-checked': classStats.linkShow}" 
	              	name="validation_name" 
	              	placeholder="填写该视频的来源URL地址，目前只支持腾讯视频..." 
	              	v-model="videoInfo.link" 
	              	@input="checkAddLink">
	            </div>
            </div>
          </form>
				</div>
		  </div>
		  <div class="bk-open-bottom">
				<button class="bk-button bk-primary bk-width ml10" @click="changeVideoList">立即添加</button>
				<button class="bk-button bk-default bk-width" @click="closePopup">取消</button>
		  </div>
		  <div class="icon-cell bk-icon-close" @click="closePopup">
        <i class="bk-icon icon-close"></i>
	    </div>
		</div>
		<!-- 修改视频弹框效果 /-->
		<div class="bk-open-addvideo" v-show="changeVideo">
		  <div class="bk-open-top">
				<div class="bk-open-img">
				  <div>
						<img :src="changeInfo.logo" v-show="!images.coverUploaded" class="bk-img"></p>
				  	<img :src="images.coverImg.indexOf('?') == 0 ? '' : images.coverImg" alt="" v-show="images.coverUploaded" class="bk-img"/>
					</div>
				  <div class="mask-loading" v-show="images.coverUploading">
            <div class="loading-box">
	            <div class="loading">
                <div class="strip1 strip"></div>
                <div class="strip2 strip"></div>
                <div class="strip3 strip"></div>
                <div class="strip4 strip"></div>
                <div class="strip5 strip"></div>
                <div class="strip6 strip"></div>
                <div class="strip7 strip"></div>
                <div class="strip8 strip"></div>
                <div class="strip9 strip"></div>
                <div class="strip10 strip"></div>
                <div class="strip11 strip"></div>
                <div class="strip12 strip"></div>
	            </div>
	            <div class="text">
	                正在上传图片...
	            </div>
            </div>
        	</div>
			    <input type="file" name="avatar" class="bk-change-img" accept="image/*" @change="imgOnChange($event, 'cover')" title="更换图片">
				</div>
				<div class="bk-open-form">
				  <form class="bk-form">
			    	<div class="bk-form-item">
			    		<label class="bk-label">选择封面：</label>
	            <div class="bk-form-content">
	              <div class="bk-open-file" >
	              	选择文件
	              	<input type="file" accept="image/*" @change="imgOnChange($event, 'cover')"/>
	              </div>
	              <span class="bk-open-span">图片类型仅支持jpg/jpeg/png</span>
	            </div>
	          </div>
            <div class="bk-form-item bk-form-mt">
	            <label class="bk-label">视频名称：</label>
	            <div class="bk-form-content" >
	              <input 
	              	type="text" 
	              	class="bk-form-input" 
	              	v-bind:class="{'bk-input-checked': changeStats.titleShow}" 
	              	name="validation_name" 
	              	placeholder="填写该视频内容的主要标题，最多10个字" 
	              	v-model="changeInfo.title" 
	              	@input="checkChangeTitle">
	            </div>
            </div>
            <div class="bk-form-item">
	            <label class="bk-label">视频链接：</label>
	            <div class="bk-form-content" > 
	              <input 
	              	type="text" 
	              	class="bk-form-input" 
	              	v-bind:class="{'bk-input-checked': changeStats.linkShow}" 
	              	name="validation_name" 
	              	placeholder="填写该视频的来源URL地址，目前只支持腾讯视频..." 
	              	v-model="changeInfo.url" 
	              	@input="checkChangeUrl">
	            </div>
            </div>
          </form>
				</div>
		  </div>
		  <div class="bk-open-bottom">
				<button class="bk-button bk-primary bk-width ml10" @click="changeVideoInfo()">确认</button>
				<button class="bk-button bk-default bk-width" @click="closePopup">取消</button>
		  </div>
		  <div class="icon-cell bk-icon-close" @click="closePopup">
        <i class="bk-icon icon-close"></i>
	    </div>
		</div>
		<!-- 删除文档弹框效果 -->
		<div class="bk-open-deletedoc" v-show="deleteDoc">
		  <div class="bk-doc-top">
		  	<p>请确认是否删除</p>
		  </div>
		  <div class="bk-doc-content">
		  	<p>你正在删除产品<span v-html="docsInfo"></span>，删除后数据将无法恢复，请谨慎操作</p>
		  </div>
		  <div class="bk-doc-btn">
		  	<button class="bk-button bk-danger bk-width" @click="deleteIndexDoc">确定</button>
		  	<button class="bk-button bk-default bk-width ml10" @click="closePopup">取消</button>
		  </div>
		</div>
		<!-- 删除视频弹框效果 -->
		<div class="bk-open-deletedoc" v-show="deleteOpenVideo">
		  <div class="bk-doc-top">
		  	<p>请确认是否删除</p>
		  </div>
		  <div class="bk-doc-content">
		  	<p style="text-align: center;">你是否确定要删除该作品视频？</p>
		  </div>
		  <div class="bk-doc-btn">
		  	<button class="bk-button bk-danger bk-width" @click="deleteVideo">确定</button>
		  	<button class="bk-button bk-default bk-width ml10" @click="closePopup">取消</button>
		  </div>
		</div>
		<!-- 弹窗 -->
    <div class="personal-pops" v-show="images.isShowImageEditor">
	    <div class="pops-content">
        <h4>
	        {{ images.editImageTitle }}剪裁
	        <a class="fr pops-close" href="javascript:;" @click="closeImageEditor">
	            <img src="../../../images/personal_center/pops-close.png" alt="" />
	        </a>
        </h4>
        <div class="editor">
          <img :src="images.imageWaitingForCrop" alt="" id="editor">
        </div>
        <div class="btn-row">
	        <div class="fl">
            <a type="button" class="btn" data-type="controller" data-method="zoom" data-options="0.1" title="放大">
	            <span class="docs-tooltip">
	              <span class="glyphicon glyphicon-zoom-in" aria-hidden="true"></span>
	            </span>
            </a>
            <a type="button" class="btn" data-type="controller" data-method="zoom" data-options="-0.1" title="缩小">
	            <span class="docs-tooltip">
	              <span class="glyphicon glyphicon-zoom-out" aria-hidden="true"></span>
	            </span>
            </a>
            <a type="button" class="btn" data-type="controller" data-method="move" data-options="-10" data-second-options="0" title="左移">
	            <span class="docs-tooltip">
	              <span class="glyphicon glyphicon-arrow-left" aria-hidden="true"></span>
	            </span>
            </a>
            <a type="button" class="btn" data-type="controller" data-method="move" data-options="10" data-second-options="0" title="右移">
	            <span class="docs-tooltip">
	              <span class="glyphicon glyphicon-arrow-right" aria-hidden="true"></span>
	            </span>
            </a>
            <a type="button" class="btn" data-type="controller" data-method="move" data-options="0" data-second-options="-10" title="上移">
	            <span class="docs-tooltip">
	              <span class="glyphicon glyphicon-arrow-up" aria-hidden="true"></span>
	            </span>
            </a>
            <a type="button" class="btn" data-type="controller" data-method="move" data-options="0" data-second-options="10" title="下移">
	            <span class="docs-tooltip">
	              <span class="glyphicon glyphicon-arrow-down" aria-hidden="true"></span>
	            </span>
            </a>
	        </div>
	        <button type="button" name="button" class="confirm-image-editor" @click="confirmCrop">确定</button>
        </div>
	    </div>
    </div>
		<!-- 弹出框子组件 -->
		<v-alert :options="options"></v-alert>
		<!-- 加载的子组件 -->
    <v-loading :ifLoadingStart="isProductLoading" class="loadingStyle"></v-loading>
  </div>
</template>

<script type="text/javascript">
	import vAlert from '../../alert.vue'    //导入弹出框子组件
	import vLoading from '../../loading.vue'    //导入弹出框子组件
	import Cropper from 'cropperjs'
  export default {
  	components: {
      vAlert,
      vLoading
    },
  	data () {
  	  return {
				saveFlag: true, //提交按钮
  	  	isProductLoading: true,    // 默认显示加载组件
  	  	shade: false,    //弹窗背景
	  		addVideo: false,    //添加弹窗
	  		changeVideo: false,    //修改弹窗
	  		deleteDoc: false,    //删除文档弹窗
	  		deleteOpenVideo: false,    //删除视频弹窗
	  		workAccessory: true,    //作品附件切换
	  		addDisabled: false,    //禁用提交按钮
	  		ableToUpload: false,    // 能否上传
	  		docxIndex: null,    //记录文档的index值
	  		VideoIndex: null,    //记录视频的Index值
	  		workId: this.$route.params.wid,    //用户Id
	  		docsInfo: '',    //记录文档信息名称
	  		videoOpenInfo: '',    //记录视频信息名称
	  		options: {				//弹出子组件配置参数
	        msgText: "",
	        msgIsSuccess: true
	      },
	  		files: {		//上传文件返回结果
	  			file: {},
	  			fileId: null,
	  		},
	  		uploadFiles: [],    //上传文件所有信息
	  		loadingIndex: 0,    //记录上传文件的index值
	  		fileIdArr: [],    //上传文件所有ID
	  		loadingStatus: '',
	  		video: {
	  		  avatarIndex: -1,    //当前视频的索引值
	  		  index: null,    //记录选中需要修改视频的索引值
	  		},
	  		images: {                  //图片剪裁相关配置
	        coverImg: '',           //封面图片地址
	        coverImgId: null,         //封面图片地址id
	        coverUploading: false,  //封面上传loading
	        coverUploaded: false,   //封面是否已上传
	        isShowImageEditor: false,
	        editImageTitle: '',
	        editImageType: '',      //当前裁剪的类型为封面
	        imageWaitingForCrop: '',
	        cropper: null           //裁剪图片插件对象
	      },
	      videoList: [],    //视频列表
	  		docxList: [],    //附件文档列表
	  		videoInfo: {    //添加信息绑定
	  			title: '',
	  			link: ''
	  		},
	  		changeInfo: {
	  			title: '',
	  			logo: '',
	  			file: '',
	  			url: '',
	  			index: 0
	  		},
	  		classStats: {    //添加视频校验状态
	  			titleShow: false,
	  			linkShow: false
	  		},
	  		changeStats: {    //修改视频校验状态
	  			titleShow: false,
	  			linkShow: false
	  		}
  	  }
  	},
  	methods: {
  		/*
      ** 获取视频/文档列表数据
      */
     	getVideoList () {
     		axios.all([
     			axios.get(myUrl + `core/product/info/${this.workId}/?keyword=videos`),
     			axios.get(myUrl + `core/product/info/${this.workId}/?keyword=docs`),
     		]).then(axios.spread((userResp,reposResp) => {
     			this.isProductLoading = false;
     			this.videoList = userResp.data.data;
     			this.docxList = reposResp.data.data;
     			if (!this.docxList.length || !this.fileIdArr.length) {
     				this.addDisabled = true;
     			}
     		}))
     	},
     	/*
      ** 添加视频列表数据
      */
     	changeVideoList () {
     		if (!this.images.coverImgId) {
     			this.options = {
            msgIsSuccess: false,
            msgText: '视频图片不能为空！'
          }
     			return;
     		} else if (!this.videoInfo.title) {
     			this.classStats.titleShow = true;
     			this.options = {
            msgIsSuccess: false,
            msgText: '视频名称不能为空！'
          }
     			return;
     		} else if (!this.videoInfo.link) {
     			this.classStats.linkShow = true;
     			this.options = {
            msgIsSuccess: false,
            msgText: '视频链接不能为空！'
          }
     			return;
     		} else {
     			this.classStats.titleShow = false;
     			this.classStats.linkShow = false;
     		}
     		
     		let reg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/;
     		if (this.videoInfo.title.length > 10) {
     			this.options = {
            msgIsSuccess: false,
            msgText: '视频名称超过10个字符！'
          }
     			return;
     		} else if (!reg.test(this.videoInfo.link)) {
     			this.options = {
            msgIsSuccess: false,
            msgText: '视频链接格式不匹配！'
          }
     			return;
     		}
     		
     		for (let i = 0; i < this.videoList.length; i++ ) {
     			if (this.videoInfo.title === this.videoList[i].title) {
     				this.options = {
	            msgIsSuccess: false,
	            msgText: '视频名称已存在！请重新填写'
	          }
     				return
     			} else if (this.videoInfo.link === this.videoList[i].url) {
     				this.options = {
	            msgIsSuccess: false,
	            msgText: '视频链接已存在！请重新填写'
	          }
     				return
     			}
     		}
     		
     		let video = {};
     		video.id = [];
     		video.link = [];
     		video.title = [];
     		for(let i = 0; i < this.videoList.length; i++) {
     			video.id.push(this.videoList[i].file);
     			video.link.push(this.videoList[i].url);
     			video.title.push(this.videoList[i].title);
     		}
				
				video.id.push(this.images.coverImgId);
				video.link.push(this.videoInfo.link);
				video.title.push(this.videoInfo.title);
    			
				let params = {
					keyword: 'videos',
					videos: JSON.stringify(video)
				}
				
        axios.post(myUrl + `core/product/update/${this.workId}/`, qs.stringify(params)).then((res) => {
        	if (res.data.result) {
        		this.images.coverImgId = null;
        		this.images.coverUploaded = false;
        		this.options = {
	            msgIsSuccess: true,
	            msgText: '提交成功！'
	          }
        		this.closePopup();
        		this.getVideoList();
        	} else {
        		this.options = {
	            msgIsSuccess: false,
	            msgText: res.data.message
	          }
        	}
        })
     	},
     	/*
      ** 修改视频数据
      */
      changeVideoInfo () {
      	let index = this.changeInfo.index;
      	
      	if (!this.changeInfo.title) {
     			this.options = {
            msgIsSuccess: false,
            msgText: '视频名称不能为空！'
          }
     			return;
     		} else if (!this.changeInfo.url) {
     			this.options = {
            msgIsSuccess: false,
            msgText: '视频链接不能为空！'
          }
     			return;
     		}
     		
     		let reg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/;
     		if (this.changeInfo.title.length > 10) {
     			this.options = {
            msgIsSuccess: false,
            msgText: '视频名称超过10个字符！'
          }
     			return;
     		} else if (!reg.test(this.changeInfo.url)) {
     			this.options = {
            msgIsSuccess: false,
            msgText: '视频链接格式不匹配！'
          }
     			return;
     		}
     		
     		for (let i = 0; i < this.videoList.length; i++ ) {
     			if (index === i) {
     				continue
     			}
     			if (this.changeInfo.title === this.videoList[i].title) {
     				this.options = {
	            msgIsSuccess: false,
	            msgText: '视频名称已存在！请重新填写'
	          }
     				return
     			} else if (this.changeInfo.link === this.videoList[i].url) {
     				this.options = {
	            msgIsSuccess: false,
	            msgText: '视频链接已存在！请重新填写'
	          }
     				return
     			}
     		}
     		
     		let video = {};
     		video.id = [];
     		video.link = [];
     		video.title = [];
     		for(let i = 0; i < this.videoList.length; i++) {
     			video.id.push(this.videoList[i].file);
     			video.link.push(this.videoList[i].url);
     			video.title.push(this.videoList[i].title);
     		}
     		
     		if ( !this.images.coverImgId ) {
					video.id[index] = this.changeInfo.file;
					video.link[index] = this.changeInfo.url;
					video.title[index] = this.changeInfo.title;
				} else {
					video.id[index] = this.images.coverImgId;
					video.link[index] = this.changeInfo.url;
					video.title[index] = this.changeInfo.title;
				}
				
				let params = {
					keyword: 'videos',
					videos: JSON.stringify(video)
				}
				
        axios.post(myUrl + `core/product/update/${this.workId}/`, qs.stringify(params)).then((res) => {
        	if (res.data.result) {
        		this.images.coverImgId = null;
        		this.options = {
	            msgIsSuccess: true,
	            msgText: '提交成功！'
	          }
        		this.closePopup();
        		this.getVideoList();
        	} else {
        		this.options = {
	            msgIsSuccess: false,
	            msgText: res.data.message
	          }
        	}
        })
      },
      /*
      ** 验证添加
      */
      checkAddTitle () {
      	if (!this.videoInfo.title) {
     			this.classStats.titleShow = true;
     		} else if (this.videoInfo.title.length > 10) {
     			this.classStats.titleShow = true;
     		} else {
     			this.classStats.titleShow = false;
     		}
      },
      checkAddLink () {
      	let reg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/;
      	if (!this.videoInfo.link) {
      		this.classStats.linkShow = true;
      	} else if (!reg.test(this.videoInfo.link)) {
      		this.classStats.linkShow = true;
      	} else {
      		this.classStats.linkShow = false;
      	}
      },
      /*
      ** 验证修改
      */
      checkChangeTitle () {
      	if (!this.changeInfo.title) {
     			this.changeStats.titleShow = true;
     		} else if (this.changeInfo.title.length > 10) {
     			this.changeStats.titleShow = true;
     		} else {
     			this.changeStats.titleShow = false;
     		}
      },
      checkChangeUrl () {
      	let reg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/;
      	if (!this.changeInfo.url) {
      		this.changeStats.linkShow = true;
      	} else if (!reg.test(this.changeInfo.url)) {
      		this.changeStats.linkShow = true;
      	} else {
      		this.changeStats.linkShow = false;
      	}
      },
     	/*
      ** 添加文档列表数据
      */
     	changeDocxList () {
				this.saveFlag = false;
        setTimeout(() => {
          this.saveFlag = true
        }, 3000)
     		let docs = [];
     		for (let i = 0; i < this.docxList.length; i++) {
     			docs.push(this.docxList[i].file);
     		}
     		for (let i = 0; i < this.fileIdArr.length; i++) {
     			docs.push(this.fileIdArr[i]);
     		}
     		
     		let params = {
     			keyword: 'docs',
					docs: JSON.stringify(docs)
     		};
     		
     		axios.post(myUrl + `core/product/update/${this.workId}/`, qs.stringify(params)).then((res) => {
        	if (res.data.result) {
						this.saveFlag = true;
        		this.fileIdArr = [];
        		this.uploadFiles = [];
        		this.loadingIndex = 0;
        		this.options = {
	            msgIsSuccess: true,
	            msgText: '提交成功！'
	          }
        		this.changeDoxc();
        		this.getVideoList();
        	} else {
        		this.options = {
	            msgIsSuccess: false,
	            msgText: res.data.message
	          }
        	}
        })
     	},
      /*
      ** 显示和隐藏添加视频窗口
      */
      openAddvideo () {
      	this.shade = !this.shade;
        this.addVideo = !this.addVideo;
      },
      /*
      ** 显示和隐藏修改视频窗口
      */
      openChangevideo (item, index) {
      	this.changeInfo.file = item.file;
      	this.changeInfo.title = item.title;
      	this.changeInfo.url = item.url;
      	this.changeInfo.logo = item.logo;
      	this.changeInfo.index = index;
      	this.shade = !this.shade;
        this.changeVideo = !this.changeVideo;
      },
      /*
      ** 点击阴影关闭所有弹窗
      */
      closePopup () {
      	this.shade = false;
      	this.addVideo = false;
      	this.changeVideo = false;
      	this.deleteDoc = false;
      	this.deleteOpenVideo = false;
      	this.videoInfo.title = "";
      	this.videoInfo.link = "";
      	this.images.coverUploaded = false;
      	this.images.coverImgId = '';
      },
      /*
      ** 鼠标经过事件显示修改视频
      ** 鼠标离开事件除去修改视频
      */
      showCurVideo (index) {
      	this.video.avatarIndex = index;
      	this.video.index = index;
      },
      hideCurVideo () {
      	this.video.avatarIndex = -1;
      },
      /*
      ** 删除视频列表的文档弹窗
      */
      deleteTheVideo (item, index) {
      	this.deleteOpenVideo = !this.deleteOpenVideo;
      	this.videoOpenInfo = item.title;
      	this.shade = !this.shade;
      	this.VideoIndex = index;
      },
      /*
      ** 删除列表中的视频
      */
      deleteVideo () {
      	let video = {};
     		video.id = [];
     		video.link = [];
     		video.title = [];
     		for(let i = 0; i < this.videoList.length; i++) {
     			video.id.push(this.videoList[i].file);
     			video.link.push(this.videoList[i].url);
     			video.title.push(this.videoList[i].title);
     		}
     		
 				video.id.splice(this.VideoIndex, 1);
 				video.link.splice(this.VideoIndex, 1);
    		video.title.splice(this.VideoIndex, 1);
    		
    		let params = {
					keyword: 'videos',
					videos: JSON.stringify(video)
				}
    		
    		axios.post(myUrl + `core/product/update/${this.workId}/`, qs.stringify(params)).then((res) => {
        	if (res.data.result) {
        		this.images.coverImgId = null;
        		this.options = {
	            msgIsSuccess: true,
	            msgText: '删除成功！'
	        }
        		this.closePopup();
        		this.getVideoList();
        	} else {
        		this.options = {
	            msgIsSuccess: false,
	            msgText: res.data.message
	          }
        	}
        })
      },
      /*
      ** 切换作品附件页面
      */
      changeDoxc () {
      	this.workAccessory = !this.workAccessory;
      	this.uploadFiles = []
      },
      /*
      ** 删除文档列表的文档弹窗
      */
      deleteDocx (item, index) {
      	this.deleteDoc = !this.deleteDoc;
      	this.docsInfo = item.name;
      	this.shade = !this.shade;
      	this.docxIndex = index;
      },
      /*
      ** 删除文档列表中的文档
      */
      deleteIndexDoc () {
      	let docs = [],
      			index = this.docxIndex;
     		for(let i = 0; i < this.docxList.length; i++) {
     			docs.push(this.docxList[i].file);
     		}
     		
     		docs.splice(index, 1);
      			
     		let params = {
     			keyword: 'docs',
					docs: JSON.stringify(docs)
     		};
     		
     		axios.post(myUrl + `core/product/update/${this.workId}/`, qs.stringify(params)).then((res) => {
        	if (res.data.result) {
        		this.options = {
	            msgIsSuccess: true,
	            msgText: '删除成功！'
	          }
        		this.closePopup();
        		this.getVideoList();
        	} else {
        		this.options = {
	            msgIsSuccess: false,
	            msgText: res.data.message
	          }
        	}
        })
      },
      /*
      ** 作品附录文件下载
      */
      downLoad (item) {
      	axios.post(myUrl + "core/product/download/docs/" + item + '/').then((res) => {
	        if(res.data.result) {
	          this.fileUrl = res.data.data;
	          window.open(this.fileUrl)
	        }
	        else {
	          this.options = {
	            msgIsSuccess: false,
	            msgText: res.data.message
	          }
	        }
	      })
      },
      /*
      ** 选择上传文件
      */
      handleFile(e) {
      	this.addDisabled = true;
        let fileInfo = e.target.files[0];
        // let maxSize = 100000; // 100MB
        let maxSize = 1024 * 1024 * 500; // 500kb
        let fileSize = fileInfo.size / 1024; // kb
        let fileName = fileInfo.name;
        let fileType = /\.[^\.]+$/.exec(fileName);
        this.loadingStatus = 'start';
        
        //判断上传的文件大小
        if (fileSize <= maxSize) {
        	let fileTypes = ['.zip', '.pdf', '.tgz', '.gz', '.rar', '.gzip', '.tar', '.doc', '.docx', '.jpg', '.xls', '.png', '.7z'];
        	if (fileType.length && fileTypes.indexOf(fileType[0]) > -1) {
	          this.files.file = fileInfo;
	          this.ableToUpload = true;
	          // 全部判断通过后，调用文件上传接口
	          let data = new FormData();
	          data.append("file", fileInfo);
	          data.append('file_type', 4) //定值，0为文件，1为图片, 4为doc
	          data.append('file_name', fileName)
	          data.append('file_format', 'file')
	          let index = this.uploadFiles.length;
						this.uploadFiles.push(fileInfo);
						
						if (this.uploadFiles.length > 10) {
							this.options = {
	              msgIsSuccess: false,
	              msgText: '最多上传10个文件'
	            }
							return
						}
						
	          axios.post(myUrl + 'core/product/upload/', data, {
	            headers: {
	              'Content-Type': 'multipart/form-data'
	            },
	          }).then((res) => {
	            let resFileData = res.data;
	            if (resFileData.result) {
	              this.loadingStatus = 'complete';
	              this.loadingIndex += 1;
	              this.addDisabled = false;
	              this.options = {
	                msgIsSuccess: true,
	                msgText: '上传成功'
	              }
	              this.files.fileId = resFileData.data;
	              this.fileIdArr.push(resFileData.data);
	            } else {
	            	this.ableToUpload = true;
	            	this.uploadFiles.splice(index, 1)
	              // 错误提示
	              this.options = {
	                msgIsSuccess: false,
	                msgText: res.data.message
	              }
	            }
	          }, res => {
	          	this.options = {
		            msgIsSuccess: false,
		            msgText: res.data.message
		          }
	          })
          } else {
            this.ableToUpload = true;
            if (this.uploadFiles.length) {
            	this.addDisabled = false;
            }
            this.options = {
              msgIsSuccess: false,
              msgText: '文件格式非法，只能上传.tgz, .zip, .gz, .rar, .gzip, .tar, .doc, .docx, .jpg, .xls, .xlsx, .png, .7z文件！'
            }
          }
        } else {
        	this.ableToUpload = true;
        	if (this.uploadFiles.length) {
	        	this.addDisabled = false;
	        }
          this.options = {
            msgIsSuccess: false,
            msgText: '该文件大小超过100MB！'
          }
        }
      },
      /*
      ** 删除上传文件
      */
      deleteFile() {
        this.files = {};
        this.ableToUpload = true;
      },
      /*
	    ** 封面图片选择后回调
	    */
	    imgOnChange(e, type) {
        let images = this.images,
            target = e.target,
            btnType = type + 'Btn',
            objType = type + 'Obj';

        images.editImageType = type;
        images.isShowImageEditor = true;
        images[btnType] = target;

        if (target.files) {
	        images[objType] = target.files[0];
	        images.imageWaitingForCrop = this._createLocalURL(images[objType]);
        }
        else {
	        target.select();
	        images.imageWaitingForCrop = document.selection.createRange().text;
        }
        if (type == 'cover') {
          images.editImageTitle = '作品封面';
        }

        setTimeout(() => {
          this.initCropper();
        }, 20);
	    },
	    /*
	     ** 关闭图片
	     */ 
	    closeImg (e, type) {
	      let images = this.images,
	          target = e.target;
	
	      images[type + 'Img'] = '';
	      images[type + 'Obj'] = null;
	      images[type + 'Btn'] = null;
	      images[type + 'Index'] = -1;
	      images[type + 'Uploaded'] = false;
	      images[type + 'Uploading'] = false;
	    },
	    /*
	    ** 初始化Cropper
	    */
	    initCropper() {
        let options = {
          cropBoxResizable: false
        }

        if (this.images.editImageType == 'cover') {
          options.aspectRatio = 250 / 141;
          options.minCropBoxWidth = 250;
          options.minCropBoxHeight = 141;
        }

        this.images.cropper = new Cropper(document.querySelector('#editor'), options);

        this._bindCropperEvents();
	    },
	    /*
	    ** 绑定裁剪图片按钮事件绑定
	    */
	    _bindCropperEvents() {
        let cropper = this.images.cropper;

        $('[data-type="controller"]').each((index, item) => {
	        $(item).on('click', function () {
            let $this = $(this);
            cropper[$this.attr('data-method')]($this.attr('data-options'), $this.attr('data-second-options'));
	        });
        });
	    },
	    /*
	    ** 解除绑定事件，避免下次初始化重复绑定，且this.images.cropper对象即将被销毁
	    */
	    _unbindCropperEvents() {
        $('[data-type="controller"]').each((index, item) => {
          $(item).off('click');
        });
	    },
	    /*
	     ** 关闭图片剪裁弹窗
	     */
	    closeImageEditor() {
        let images = this.images;

        this._unbindCropperEvents();
        this._destroyLocalURL(this.imageWaitingForCrop);
        images.isShowImageEditor = !images.isShowImageEditor;
        images[images.editImageType + 'Btn'].value = '';    //重置选中的图片
        images.cropper.destroy();
	    },
	    /*
	    ** 创建图片本地地址
	    */
	    _createLocalURL(file) {
        if (window.createObjectURL) {
          return window.createObjectURL(file);
        }
        else if (window.URL) {
          return window.URL.createObjectURL(file);
        }
        else if (window.webkitURL.createObjectURL) {
          return window.webkitURL.createObjectURL(file);
        }
	    },
	    /*
	     ** 手动释放图片的本地地址
	     */
	    _destroyLocalURL(url) {
        if (window.revokeObjectURL) {
          return window.revokeObjectURL(url);
        }
        else if (window.URL) {
          return window.URL.revokeObjectURL(url);
        }
        else if (window.webkitURL.revokeObjectURL) {
          return window.webkitURL.revokeObjectURL(url);
        }
	    },
	    /*
	    ** 裁剪图片确定函数
	    */
	    confirmCrop() {
        let options = {
            width: 0,
            height: 0
        },
        type = this.images.editImageType,
        loading = type + 'Uploading';

        if (type == 'cover') {
          options.width = 250;
          options.height = 141;
        }

        // this.images[loading] = true;
        let result = this.images.cropper.getCroppedCanvas(options).toDataURL('image/png');
        this.images[type + 'Img'] = result;
        this.images[type + 'Uploaded'] = true;  // 已上传

        let request = {
            file: result,
            file_type: '1',
            file_name: type+'Img',
            file_format: 'base64'
        };

        axios.post(myUrl + 'core/product/upload/', qs.stringify(request)).then(response => {
	        //提交裁剪的图片后的回调函数
	        let res = response.data,
	            data = res.data;
	  
	        if (res.result) {
	            this.images[type+"ImgId"] = data;
	            this.images.coverImgId = data;
	            this.images[loading] = false;
	            
	            this.$emit("upPictureId",this.images[type+"ImgId"]);
	        }
        }, reject => {
          console.log(reject);
        });
        this.images[loading] = false;
        this.closeImageEditor();
	    },
  	},
  	created () {
  	  this.getVideoList();
  	}
  }
</script>

<style media="screen" lang="scss" scoped>
  .attention{
    padding: 27px 40px;
    display: table;
  }
  /*
  ** 小图标样式
  */
  .attention {
  	.bk-icon {
  	  display: inline-block;
  	  &.icon-download,
      &.icon-delete {
        position: relative;
        font-size: 14px;
        padding: 8px;
        cursor: pointer;
        border-radius: 2px;
      }
      &.icon-download {
        &:hover {
          background: #57a3f1;
          color: #ffffff;
        }
      }
      &.icon-delete {
        &:hover {
          background: #ff5656;
          color: #ffffff;
        }
      }
  	}
  }
  /*
  ** 鼠标进过图标显示文字
  */
  .bk-icon {
    position: relative;
    .tips {
      position: absolute;
      top: -38px;
      left: 50%;
      -webkit-transform: translateX(-50%);
      transform: translateX(-50%);
      display: none;
      font-size: 12px;
      color: #ffffff;
      line-height: 30px;
      padding: 0 10px;
      background: rgba(0, 0, 0, 0.8);
      border-radius: 2px;
      font-style: normal;
      white-space: nowrap;
      &:after {
        content: '';
        position: absolute;
        left: 50%;
        bottom: -12px;
        width: 0;
        height: 0;
        border: 6px solid rgba(0, 0, 0, 0.8);
        border-color: rgba(0, 0, 0, 0.8) transparent transparent transparent;
        margin-left: -6px;
      }
    }
    &:hover {
      .tips {
        display: inline-block;
      }
    }
  }
  /*
  ** table表格样式
  */
  .bk-table {
  	tr > td {
  	  line-height: 30px;
  	  text-align: center;
  	  &:nth-child(1) {
  		text-align: left; 
  	  }
  	}
  }
  /*
  ** 作品视频
  */
  .video {
    padding: 0 40px 40px 40px;
    border-bottom: 10px solid #f4f4f4;
    h4 {
      padding: 20px 0;
      font-size: 18px;
      font-weight: bold;
      color: #77787f;
      overflow: hidden;
      > span {
      	font-size: 14px;
      	color: #a6a6a6;
      	font-weight: normal;
      }
      .bk-word {
      	margin-left: 12px;
      }
      .bk-num {
      	float: right;
      	margin-top: 2px;
      }
    }
    .bk-add-video {
      border: 1px solid #f4f4f4;
      border-bottom: none;
      .bk-video-list {
      	width: 100%;
      	background-color: #fafafa;
      	overflow: hidden;
      	> li {
      	  width: 33.3333%;
      	  box-sizing: border-box;
      	  overflow: hidden;
      	  padding: 12px;
      	  background-color: #ffffff;
      	  border-right: 1px solid #f4f4f4;
      	  border-bottom: 1px solid #f4f4f4;
      	  float: left;
      	  &:nth-child(3n) {
      	  	border-left: none;
      	  	border-right: none;
      	  }
      	  &.show-line {
      	  	background-color: #fafafa;
      	  	height: 198px;
      	  	box-sizing: border-box;
      	  	border-bottom: none;
      	  }
      	  &.bk-background {
      	  	background-color: #fafafa;
      	  	cursor: pointer;
      	  	border-bottom: none;
      	  	> p {
      	  		opacity: 0;
      	  	}
      	  }
      	  .bk-video-img {
      	  	position: relative;
      	  	cursor: pointer;
      	  	> img {
      	  	  width: 250px!important;
      	  	  height: 141px!important;
      	  	}
      	  	.bk-shade {
      	  	  position: absolute;
      	  	  top: 0;
      	  	  left: 0;
      	  	  width: 100%;
      	  	  height: 100%;
      	  	  background-color: #535353;
      	  	  > img {
      	  	  	position: absolute;
      	  	  	top: 50%;
      	  	  	left: 50%;
      	  	  	transform: translate(-50%,-50%);
      	  	  	margin-top: -15px;
      	  	  }
      	  	  > p {
      	  	  	position: absolute;
      	  	  	top: 50%;
      	  	  	left: 50%;
      	  	  	transform: translate(-50%,-50%);
      	  	  	margin-top: 20px;
      	  	  	font-size: 14px;
      	  	  	color: #ffffff;
      	  	  }
      	  	  .icon-error {
		            z-index: 999;
		            position: absolute;
		            right: 5px;
		            top: 5px;
		            display: inline-block;
		            width: 20px;
		            height: 20px;
		            background: url(../../../images/common/error.png) no-repeat;
		            background-size: cover;
		            cursor: pointer;
		          }
      	    }
      	  }
      	  > p {
      	  	text-align: center;
      	  	color: #4f515e;
      	  	margin-top: 12px;
      	  	font-size: 14px;
      	  	font-weight: bold;
      	  }
      	}
      }
    }
  }
  /*
  ** 作品附件
  */
  .bk-accessory {
  	padding: 0 40px 40px 40px;
  	width: 911px;
  	box-sizing: border-box;
  	h4 {
  	  padding: 20px 0;
      font-size: 18px;
      font-weight: bold;
      color: #77787f;
      overflow: hidden;
      border-bottom: 1px solid #f4f4f4;
      > span {
      	font-size: 14px;
      	color: #a6a6a6;
      	font-weight: normal;
      	margin-left: 12px;
      }
  	}
  	.bk-add-accessory {
      .bk-add-btn {
      	padding: 20px 0px;
      }
  	  .bk-table-list {
  	  	.bk-img-word {
  	  		margin-left: 5px;
  	  		max-width: 200px;
  	  		overflow: hidden;
			    display: inline-block;
			    vertical-align: middle;
			    text-overflow: ellipsis;
  	  	}
  	  }
  	}
  	.bk-add-docx {
  		width: 831px;
  		margin-top: 20px;
  		.bk-docx-top {
  			border: 1px dashed #e6e6e6;
  			background-color: #fafafa;
  			text-align: center;
  			overflow: hidden;
  			position: relative;
  			> p {
  				font-size: 14px;
  				color: #a6a6a6;
  				.icon-upload {
  					margin-right: 10px;
  				}
  				.bk-add {
  					color: #3C96FF;
  				}
  				&.mt20 {
  					margin-top: 20px;
  				}
  				&.mt10 {
  					margin-top: 10px;
  				}
  				&.mb25 {
  					margin-bottom: 25px;
  				}
  			}
  		.bk-docx-file {
  			position: absolute;
  			top: 0;
  			left: 0;
  			width: 100%;
  			height: 100%;
  			opacity: 0;
  			overflow: hidden;
  			cursor: pointer;
  		}
  		}
  		.bk-docx-content {
  			margin-top: 20px;
  			margin-bottom: 20px;
  			.bk-upload-ul {
			    .bk-list-li {
			    	box-sizing: border-box;
			    	margin-bottom: 10px;
			      height: 60px;
			      border: 1px solid #e6e6e7;
			      border-radius: 2px;
			      padding: 15px;
			      width: 407px;
			      display: inline-block;
			      &:nth-child(2n) {
			      	margin-left: 10px;
			      }
			      .icon-file-zip {
			        display: inline-block;
			        width: 30px;
			        height: 30px;
			        background: url(../../../images/application_detail/icon-file-zip.png) no-repeat;
			        margin-right: 10px;
			      }
			      .bk-list-content {
			        vertical-align: top;
			        top: -5px;
			        width: 332px;
			        float: right;
			        position: relative;
			        .bk-load {
			          position: absolute;
			          bottom: 0;
			          width: 100%;
			          left: 0;
			          height: 4px;
			          background: #e6e6e7;
			          display: inline-block;
			          border-radius: 2px;
			          >span {
			            position: absolute;
			            bottom: 0;
			            left: 0;
			            height: 3px;
			            width: 0;
			            background: #57a3f1;
			            -webkit-transition: all .5s;
			            -moz-transition: all .5s;
			            -ms-transition: all .5s;
			            transition: all .5s;
			          }
			          .loading {
			            width: 90%;
			          }
			          .totalLoading {
			            width: 100%;
			          }
			        }
			        .name {
			          width: 100%;
			          overflow: hidden;
			          display: inline-block;
			          height: 40px;
			        }
			        span {
			          line-height: 40px;
			          color: #888991;
			        }
			        .icon-close {
			          position: absolute;
			          right: 0;
			          cursor: pointer;
			          top: 13px;
			          left: auto;
			          font-size: 12px;
			        }
			        .icon-check-1 {
			          position: absolute;
			          right: 0;
			          cursor: pointer;
			          top: 13px;
			          left: auto;
			          color: #5bd18b;
			          font-size: 12px;
			        }
			      }
			    }
			  }
  		}
  		.bk-docx-bottom {
  			button {
  				width: 98px;
  				height: 36px;
  				margin-right: 10px;
  			}
  		}
  	}
  }
  /*
  ** 页面弹窗效果
  */
  .bk-open-shade {
  	width: 100%;
  	height: 100%;
  	background-color: rgba(0,0,0,0.5);
  	position: absolute;
  	top: 0;
  	left: 0;
  	z-index: 1000;
  	min-width: 1180px;
  	overflow: hidden;
  }
  /*
  ** 添加视频弹窗
  */
  .bk-open-addvideo {
    width: 800px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    z-index: 1001;
    .bk-open-top {
      background-color: #ffffff;
      border-bottom: 1px solid #eaeaea;
      padding: 85px 40px;
      overflow: hidden;
      .bk-open-img {
        float: left;
        width: 250px;
        height: 141px;
        border: 1px dashed #bfbfbf;
        text-align: center;
        line-height: 141px;
        font-size: 25px;
        color: #4f515e;
        font-weight: bold;
        position: relative;
        cursor: pointer;
        img {
        	width: 250px;
        	height: 141px;
        }
        .bk-img {
        	margin-top: -8px;
        	margin-left: -1px;
        }
        .bk-other-img {
        	margin-top: -1px;
        	margin-left: -1px;
        }
        .bk-open-block {
          display: block;
        }
        .bk-open-none {
          display: none;
        }
        .bk-change-img {
        	position: absolute;
        	top: 0;
        	left: 0;
        	width: 250px;
        	height: 141px;
        	opacity: 0;
        	cursor: pointer;
        }
      }
      .bk-open-form {
        margin-left: 28px;
        width: 440px;
        height: 141px;
        float: left;
        .bk-form-item {
          line-height: 38px;
          overflow: hidden;
          box-sizing: border-box;
          margin-top: 0px;
          &.bk-form-mt {
          	margin-top: 13px;
          	margin-bottom: 14px;
          }
          .bk-label {
          	color: #a6a6a6;
          }
          .bk-form-content{
          	overflow: hidden;
          	margin-left: 0px;
          	.bk-open-file {
	          	width: 96px;
	          	height: 38px;
	          	border: 1px solid #e6e6e7;
	          	box-sizing: border-box;
	          	overflow: hidden;
	          	text-align: center;
	          	line-height: 38px;
	          	position: relative;
	          	float: left;
	          	margin-left: 15px;
	          	border-radius: 2px;
	          	> input {
	          	  opacity: 0;
	          	  position: absolute;
	          	  top: 0;
	          	  left: 0;
	          	  width: 96px;
	          	  height: 38px;
	          	  cursor: pointer;
	          	  border: none;
	          	}
	          }
	          .bk-form-input {
	          	margin-left: 15px;
	          	width: 330px;
	          }
          }
          .bk-open-span {
          	margin-left: 20px;
          	float: left;
          }
          label {
          	width: 80px;
          	font-size: 16px;
          	padding: 0px;
          	line-height: 38px;
          }
        }
      }
    }
    .bk-open-bottom {
      background-color: #fafafa;
      text-align: center;
      padding: 50px 0px;
      .bk-width {
      	width: 96px;
      }
      .ml10 {
      	margin-right: 10px;
      }
    }
    .bk-icon-close {
    	position: absolute;
    	top: 19px;
    	right: 21px;
    	font-size: 18px;
    	color: #231f20;
    	cursor: pointer;
    }
  }
  /*
  ** 删除文档弹框
  */
  .bk-open-deletedoc {
  	width: 400px;
  	box-sizing: border-box;
  	position: fixed;
  	top: 50%;
  	left: 50%;
  	transform: translate(-50%,-50%);
  	z-index: 1001;
  	text-align: center;
  	padding: 45px 65px 40px;
  	background-color: #ffffff;
  	border-radius: 4px;
  	.bk-doc-top {
  		> p {
  			font-size: 24px;
  			color: #212232;
  		}
  	}
  	.bk-doc-content {
  		margin-top: 35px;
  		margin-bottom: 32px;
  		text-align: left;
  		> p {
  			font-size: 14px;
  			color: #737987;
  			> span {
  				font-weight: bold;
  			}
  		}
  	}
  	.bk-doc-btn {
  		.bk-width {
      	width: 125px;
      }
  	}
  }
  /*
  ** 图片裁剪弹框
  */
  .personal-pops{
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background: rgba(0,0,0,.3);
    z-index: 10000;
    .pops-content{
	    width: 853px;
	    height: 60%;
	    padding: 20px 24px;
	    background: #fff;
	    position: absolute;
	    left: 50%;
	    top:50%;
	    transform:translate(-50%,-50%);
	    h4{
        font-size: 16px;
        color: #090b1a;
	    }
	    .confirm-image-editor{
        width: 80px;
        height: 30px;
        background: #5bd18b;
        color: #fff;
        font-size: 16px;
        text-align: center;
        line-height: 20px;
        border-radius: 3px;
        display: inline-block;
        margin-top: 20px;
        border: none;
        box-shadow: none;
        outline: none;
	    }
	    .editor{
        height: 70%;
        margin-top: 30px;
        img{
	        width: 100%;
	        height: 100%;
        }
	    }
    }
	}
	.btn-row{
	  position: absolute;
	  width: calc(100% - 40px);
	  bottom: 20px;
	  text-align: right;
	}
	.btn{
	  padding: 4px 9px;
	  margin-top: 20px;
	  color: #fff;
	  background: #a474f3;
	  position: relative;
	  -webkit-box-flex: 0;
	  -webkit-flex: 0 1 auto;
	  -ms-flex: 0 1 auto;
	  flex: 0 1 auto;
	  outline:none;
	  &:hover{
	    background: #8d4ff3;
	  }
	}
	.mask-loading{
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.5);
    text-align: center;
    color: #fff;
    cursor: pointer;
    .loading-box{
	    position:absolute;
	    top:50%;
	    left:50%;
	    transform:translate(-50%,-50%);
    }
    .loading {
	    width: 3px;
	    height: 40px;
	    position: relative;
	    margin: 0 auto;
	    .strip{
        width: 100%;
        height: 90%;
        position: absolute;
        &:before{
        content: '';
        display: block;
        margin: 0 auto;
        width: 100%;
        height: 26%;
        background-color: #fff;
        border-radius:6px 6px 0 0;
        animation: stripFadeDelay 1.2s infinite ease-in-out both;
        }
	    }
	    .strip2 { transform: rotate(30deg);}
	    .strip3 { transform: rotate(60deg);}
	    .strip4 { transform: rotate(90deg);}
	    .strip5 { transform: rotate(120deg);}
	    .strip6 { transform: rotate(150deg);}
	    .strip7 { transform: rotate(180deg);}
	    .strip8 { transform: rotate(210deg);}
	    .strip9 { transform: rotate(240deg);}
	    .strip10 { transform: rotate(270deg);}
	    .strip11 { transform: rotate(300deg);}
	    .strip12 { transform: rotate(330deg);}
	    .strip2:before {animation-delay: -1.1s; }
	    .strip3:before { animation-delay: -1s; }
	    .strip4:before { animation-delay: -0.9s; }
	    .strip5:before { animation-delay: -0.8s; }
	    .strip6:before { animation-delay: -0.7s; }
	    .strip7:before { animation-delay: -0.6s; }
	    .strip8:before { animation-delay: -0.5s; }
	    .strip9:before { animation-delay: -0.4s; }
	    .strip10:before { animation-delay: -0.3s; }
	    .strip11:before { animation-delay: -0.2s; }
	    .strip12:before { animation-delay: -0.1s; }
	    @-webkit-keyframes stripFadeDelay {
        0%, 39%, 100% { opacity: 0.5; }
        40% { opacity: 1; }
	    }
	
	    @keyframes stripFadeDelay {
        0%, 39%, 100% { opacity: 0.5; }
        40% { opacity: 1; }
	    }
    }
	}
	.loadingStyle {
		padding-top: 200px;
	}
	.bk-input-checked {
		border-color: #ff6600 !important;
	}
</style>


// WEBPACK FOOTER //
// work_information.vue?1e3bc5fa